'use client'

import { DetailPageHeader } from '@/components/header/detail-page-header'

/**
 * Renders the integration's `Integrations / <Name>` breadcrumb into
 * the app shell header (`AppHeader`'s left slot).
 *
 * The app shell header intentionally carries only the breadcrumb — the
 * connect / disconnect CTA lives solely in the page's hero so there is
 * exactly one connect button per page. (A previous version mirrored the
 * CTA into the header's right slot; that duplicated the hero button and
 * has been removed.)
 *
 * Mounts only on the signed-in `/integrations/<provider>` route — the
 * public mirror at `/browse/integrations/<provider>` lives outside the
 * (app) layout so there is no `PageTitleProvider` to inject into. The
 * page falls back to its own inline breadcrumb in that case.
 *
 * Uses the same `DetailPageHeader` foundation as tools, automations, and
 * templates so collection → entity navigation stays visually identical.
 */
export function IntegrationHeaderInjector({ name }: { name: string }) {
  return (
    <DetailPageHeader
      parentLabel="Integrations"
      parentHref="/integrations"
      title={name}
    />
  )
}
